import { useMemo, useState } from 'react';
import { Link } from 'react-router-dom';
import MomentCard from '@/components/base/MomentCard';
import { momentCategories, moments } from '@/mocks/moments';

const tabs = [
  { key: 'latest', label: '最新收录', match: '' },
  { key: 'skill', label: '神操作', match: '神操作' },
  { key: 'awkward', label: '尴尬瞬间', match: '尴尬瞬间' },
  { key: 'shine', label: '高光瞬间', match: '高光瞬间' },
];

export default function LatestGrid() {
  const [category, setCategory] = useState('全部');
  const [tab, setTab] = useState('latest');

  const activeTab = tabs.find((item) => item.key === tab) ?? tabs[0];

  const list = useMemo(() => {
    const filtered = moments.filter((item) => {
      const categoryOk = category === '全部' || item.category === category;
      const tabOk = !activeTab.match || item.tags.includes(activeTab.match);
      return categoryOk && tabOk;
    });

    return [...filtered].sort((a, b) => (a.date < b.date ? 1 : -1));
  }, [category, activeTab]);

  return (
    <section className="px-4 md:px-8 py-14 md:py-20 bg-background-50">
      <div className="flex flex-col md:flex-row md:items-end justify-between gap-4">
        <div>
          <span className="inline-flex items-center gap-2 text-sm text-primary-700">
            <i className="ri-live-line"></i>
            最新名场面
          </span>
          <h2 className="mt-2 font-heading text-3xl md:text-4xl text-foreground-950">刚整理好的抓拍与高光</h2>
        </div>
        <Link
          to="/moments"
          className="self-start md:self-auto px-5 py-2.5 rounded-md text-sm whitespace-nowrap border border-background-300 text-foreground-800 hover:border-primary-400 hover:text-primary-700 transition-colors cursor-pointer"
        >
          进入名场面图鉴
        </Link>
      </div>

      <div className="mt-7 flex flex-col gap-4">
        <div className="flex flex-wrap gap-2">
          {momentCategories.map((item) => (
            <button
              key={item}
              type="button"
              onClick={() => setCategory(item)}
              className={`px-4 py-2 rounded-full text-sm whitespace-nowrap cursor-pointer transition-colors ${
                category === item
                  ? 'bg-primary-500 text-background-50'
                  : 'bg-background-100 text-foreground-700 hover:text-foreground-950'
              }`}
            >
              {item}
            </button>
          ))}
        </div>

        <div className="flex flex-col sm:flex-row sm:items-center justify-between gap-3">
          <div className="inline-flex items-center gap-1 rounded-full bg-background-200/70 p-1 self-start">
            {tabs.map((item) => (
              <button
                key={item.key}
                type="button"
                onClick={() => setTab(item.key)}
                className={`px-4 py-1.5 rounded-full text-sm whitespace-nowrap cursor-pointer transition-colors ${
                  tab === item.key
                    ? 'bg-background-50 text-foreground-950'
                    : 'text-foreground-600 hover:text-foreground-900'
                }`}
              >
                {item.label}
              </button>
            ))}
          </div>
          <p className="text-sm text-foreground-500">
            当前筛选出 <span className="text-primary-700">{list.length}</span> 条内容
          </p>
        </div>
      </div>

      {list.length > 0 ? (
        <div className="mt-8 grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6">
          {list.slice(0, 6).map((item) => (
            <MomentCard key={item.id} moment={item} />
          ))}
        </div>
      ) : (
        <div className="mt-8 py-16 rounded-lg border border-dashed border-background-300 text-center">
          <div className="w-14 h-14 mx-auto flex items-center justify-center rounded-full bg-background-100 text-foreground-400">
            <i className="ri-emotion-unhappy-line text-2xl"></i>
          </div>
          <p className="mt-4 text-sm text-foreground-600">这个组合暂时没有内容,换个分类或角度试试。</p>
        </div>
      )}
    </section>
  );
}